import { render, staticRenderFns } from "./customerKit.vue?vue&type=template&id=05ee9a37&scoped=true&"
import script from "./customerKit.vue?vue&type=script&lang=js&"
export * from "./customerKit.vue?vue&type=script&lang=js&"
import style0 from "./customerKit.vue?vue&type=style&index=0&id=05ee9a37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ee9a37",
  null
  
)

export default component.exports